import uuid from 'uuid/v4';

import { BridgeService } from './';

const requestsStorage = {};

const createRequest = params => {
  const id = uuid();
  const request = {
    id,
    params,
  };

  const promise = new Promise((resolve, reject) => {
    request.resolve = resolve;
    request.reject = reject;
  });

  request.promise = promise;
  requestsStorage[id] = request;

  return request;
};

const removeRequest = id => {
  delete requestsStorage[id];
};

export class CancelToken {
  constructor(callback) {
    return Promise.resolve(callback);
  }
}

export const client = {
  get: async (endpoint, data) => {
    const request = createRequest({ method: 'get', endpoint, data });

    return await BridgeService.sendHttpRequest(request);
  },

  post: async (endpoint, data, config) => {
    const request = createRequest({ method: 'post', endpoint, data, config });
    const { cancelToken } = config || {};

    if (cancelToken) {
      cancelToken.then(callback => callback(() => removeRequest(request.id)));
      delete config.cancelToken;
    }

    return await BridgeService.sendHttpRequest(request);
  },
};

export const removeAuthorizationToken = (): void =>
  BridgeService.removeHttpHeaderAuthorization();

export const resolveRequest = ({ id, error, response }) => {
  const request = requestsStorage[id];

  if (!request) {
    return;
  }

  if (error) {
    request.reject(error);
  } else {
    request.resolve(response);
  }

  removeRequest(id);
};

export const setAcceptLanguage = (locale: string): void => {
  BridgeService.setHttpHeaderAcceptLanguage(locale);
  BridgeService.setLocale(locale);
};

export const setAuthorizationToken = (accessToken: string): void =>
  BridgeService.setHttpHeaderAuthorization(accessToken);
